module.exports = __webpack_public_path__ + "static/img/2_2_1.3d4a2733.png";